import { createAction } from 'typesafe-actions';
import { INematodeAssignment } from '../../types/model/nematode/nematodeAssignment';

export default class NematodeActions {
    public static setLoadingAssignments = createAction('NEMATODE_SET_LOADING_ASSIGNMENTS', resolve => (loading : boolean) => resolve(loading));
    public static setAssignments = createAction('NEMATODE_SET_ASSIGNMENTS', resolve => (list : Array<INematodeAssignment>) => resolve(list));
}
